import { useEffect } from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import { useTranslation } from 'react-i18next'
import { fadeInAnimation } from '../../utils/cssFunctions'
import HelmetMeta from '../../layouts/HelmetMeta'

const partners = [
  { name: 'Salomon', logo: 'salomon' },
  { name: 'Ras Al Khaimah Tourism Development Authority', logo: 'rak' },
  { name: 'Salha Al Basti Advocates', logo: 'salha-albasti' },
  { name: 'Sharjah Sports Council', logo: 'sharjah-sports-council' },
  { name: 'Dubai Sports Council', logo: 'dubai-sports-council' },
  { name: 'UAE Sports For All', logo: 'uas-sports-for-all' }
]

export default function Partners () {
  const { t } = useTranslation('others')
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container sx={{ mt: 12, mb: 4 }} maxWidth='lg'>
      <HelmetMeta
        {...{
        title: t('partners.metaTitle'),
        description: t('partners.metaDescription'),
        image: '/img/races/i/ramadan-race.jpg'
      }}
      />
      <Typography
        sx={{
          fontSize: { xs: '1.5rem', md: '2rem' },
          fontWeight: 700,
          textAlign: 'center',
          mb: 6,
          mt: 2,
          ...fadeInAnimation
        }}
      >
        {t('partners.heading')}
      </Typography>

      <Typography>
        {t('partners.paragraph1')}
      </Typography><br />

      <Typography>
        {t('partners.paragraph2')}
      </Typography>
      <Button
        component={Link}
        href='mailto:info@peakssports.com'
        variant='outlined'
        color='primary'
        target='_blank'
        sx={{ color: 'white', mt: 2, '&:hover': { color: '#ddd' } }}
        startIcon={<EmailOutlinedIcon />}
      >
        {t('partners.contact')}
      </Button>
      <Divider sx={{ my: 5 }}/>

      <Typography>
        {t('partners.paragraph3')}
      </Typography><br />

      {partners.map((partner, index) => (
        <Box
          component='img'
          key={partner.logo}
          alt={partner.name}
          sx={{
            width: 120,
            borderRadius: 2,
            mr: 2,
            opacity: 0,
            animation: 'fadeInUp 0.5s ease-out forwards',
            animationDelay: `${index * 0.1}s`,
            '@keyframes fadeInUp': {
              from: {
                opacity: 0,
                transform: 'translateY(20px)'
              },
              to: {
                opacity: 1,
                transform: 'translateY(0)'
              }
            }
          }}
          src={`https://d1hi0tbu2kom2c.cloudfront.net/img/partners/${partner.logo}.png`}
        />
      ))}
    </Container>
  )
}
